//
//  CustomSignInButton.tsx
//
//  isana.net,inc. Proprietary and Confidential
//

import React from "react";
import { PUBLIC_URL } from "../utils/env";

export type CustomSignInButtonProps = {
  onClick: () => void;
  label: string;
  iconSrc: string;
  alt: string;
  backgroundColor: string;
  color: string;
  border: string;
};
export type GoogleSignInButtonProps = { onClick: () => void };
export type MicrosoftSignInButtonProps = { onClick: () => void };

export const CustomSignInButton: React.FC<CustomSignInButtonProps> = ({
  onClick,
  label,
  iconSrc,
  alt,
  backgroundColor,
  color,
  border,
}) => (
  <button
    style={{
      width: "100%",
      background: backgroundColor,
      color,
      border,
      borderRadius: 4,
      padding: 12,
      fontWeight: "bold",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: 8,
      cursor: "pointer",
    }}
    onClick={onClick}
    aria-label={label}
  >
    <img src={iconSrc} alt={alt} style={{ width: 20, height: 20 }} />
    {label}
  </button>
);

export const GoogleSignInButton: React.FC<GoogleSignInButtonProps> = ({
  onClick,
}) => (
  <CustomSignInButton
    onClick={onClick}
    label="Googleでログイン"
    iconSrc="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg"
    alt="Google"
    backgroundColor="#fff"
    color="#5F6368"
    border="1px solid #dadce0"
  />
);

export const MicrosoftSignInButton: React.FC<MicrosoftSignInButtonProps> = ({
  onClick,
}) => (
  <CustomSignInButton
    onClick={onClick}
    label="Microsoftでサインイン"
    iconSrc={`${PUBLIC_URL}/ms-symbollockup_mssymbol_19.svg`}
    alt="Microsoft"
    backgroundColor="#000"
    color="#FFFFFF"
    border="none"
  />
);
